var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fill-height"},[(_vm.pageSchema === _vm.schemas.PROJECT)?_c('ProjectsPage'):_c('FullScreenError',{staticClass:"page-content-container",attrs:{"title":_vm.$t('pages.error.title.default'),"message":_vm.$t('pages.error.message.404')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }